import { NoteColor } from './types';

export const NOTE_COLORS: Record<NoteColor, string> = {
  white: 'bg-white',
  yellow: 'bg-yellow-100',
  green: 'bg-green-100',
  blue: 'bg-blue-100',
  purple: 'bg-purple-100',
  red: 'bg-red-100',
};

export const COLOR_OPTIONS: NoteColor[] = ['white', 'yellow', 'green', 'blue', 'purple', 'red'];
